function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree } from 'antd';
import { NodePlusFill, XSquareFill } from 'react-bootstrap-icons';
import NewDepartment from "../components/forms/NewDepartment";
import NewService from "../components/forms/NewService";
import NewExam from "../components/forms/NewExam";
import Common from "../components/includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Departments = function Departments() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isNewDeptFormVisible = _useState2[0],
      setIsNewDeptFormVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isNewServiceFormVisible = _useState4[0],
      setIsNewServiceFormVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isNewItemFormVisible = _useState6[0],
      setIsNewItemFormVisible = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      serviceTree = _useState8[0],
      setServiceTree = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      dataChanged = _useState10[0],
      setDataChanged = _useState10[1];

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        response.data.services.forEach(function (d) {
          setServiceTree(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              title: d.label,
              key: 'd' + d.id.toString(),
              children: d.services.map(function (s) {
                return {
                  title: s.label,
                  key: "s" + s.id.toString(),
                  children: s.medical_items.map(function (m) {
                    return {
                      title: m.label,
                      key: "m" + m.id.toString()
                    };
                  })
                };
              })
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          sm: 9,
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "vertical",
            children: [/*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewDeptFormVisible(true);
              },
              children: "Ajouter Deptm"
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewServiceFormVisible(true);
              },
              children: "Ajouter Service"
            }), /*#__PURE__*/_jsx(Button, {
              size: "large",
              type: "primary",
              style: {
                width: '98%'
              },
              icon: /*#__PURE__*/_jsx(NodePlusFill, {
                size: 26
              }),
              onClick: function onClick() {
                setIsNewItemFormVisible(true);
              },
              children: "Ajouter un examen"
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 9,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(Tree, {
              showLine: true,
              showIcon: true,
              defaultExpandAll: true,
              autoExpandParent: true,
              defaultExpandParent: true,
              treeData: serviceTree
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un d\xE9partement",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewDepartment, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewServiceFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un service",
      onClose: function onClose() {
        setIsNewServiceFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewService, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      visible: isNewItemFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un examen",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewExam, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    })]
  });
};

export default Departments;